import type { TokenResponseConfig } from "expo-auth-session/src/TokenRequest.types";
import { atomWithStorage, createJSONStorage } from "jotai/utils";
import { Platform } from "react-native";

import { mmkv } from "./mmkv";

const createMMKVStorage = <T>() => {
  const s = createJSONStorage<T>(() => ({
    getItem: (key: string) => mmkv.getString(key) ?? null,
    setItem: (key: string, newValue: string | undefined) => {
      if (newValue === undefined) {
        mmkv.delete(key);
      } else {
        mmkv.set(key, newValue);
      }
    },
    removeItem: (key: string) => mmkv.delete(key),
  }));
  s.subscribe = (key, callback) => {
    if (Platform.OS === "web") {
      const webListener = (e: StorageEvent) => {
        if (key === e.key) {
          const v = mmkv.getString(key) ?? null;
          // eslint-disable-next-line typescript-eslint/no-unsafe-argument
          callback(v === null ? v : JSON.parse(v));
        }
      };
      window.addEventListener("storage", webListener);
      return () => {
        window.removeEventListener("storage", webListener);
      };
    }

    return () => {};
  };
  return s;
};

export function atomWithMMKV<T>(key: string, initialValue?: T) {
  return atomWithStorage<T>(`@staverton-app/${key}`, initialValue!, createMMKVStorage<T>(), {
    getOnInit: true,
  });
}

/** @deprecated Use `authAtom` instead. */
export const loginAtom = atomWithMMKV<string | undefined>("login");
export const authAtom = atomWithMMKV<TokenResponseConfig | undefined>("auth");

export const themeAtom = atomWithMMKV<"light" | "dark" | "system">("theme", "system");
export const selectedCameraIdAtom = atomWithMMKV<string | undefined>("selectedCameraId");
export const useCustomCameraAtom = atomWithMMKV<boolean>("useCustomCamera", false);

export const productLookupSortAtom = atomWithMMKV<
  "default" | "price_asc" | "price_desc" | "desc_asc" | "desc_desc" | "code_asc" | "code_desc"
>("productLookupSort", "price_asc");
